import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { FaLessThan } from 'react-icons/fa';
import QuestionGroup from "./QuestionGroup";
import Button from "reactstrap/lib/Button";
import CommunicationComponent from "../communication/CommunicationComponent";
import { flashElement, scrollElementIntoViewInContainer } from "../../helper/helper";

class QuestionPageContainer extends CommunicationComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    qCtrl() {
        return this.props.qctrl;
    }


    jumpToTop() {
        if (typeof document !== "undefined") {
            document.getElementById("questionwrapper").scrollTo({top: 0, behavior: "auto"});
        }
    }

    /**
     * Springt zur ersten unbeantworteten Frage und laesst sie aufleuchten.
     *
     * Ohne das passiert beim Klick auf "Weiter" scheinbar nichts: der rote Rahmen sitzt
     * womoeglich weit unterhalb des sichtbaren Bereichs, und der Knopf steht am Ende der
     * Seite. Gesucht wird in der Reihenfolge der Seite, nicht in der Schluesselreihenfolge
     * des Fehlerobjekts - sonst landet man irgendwo in der Mitte.
     *
     * Verzoegert, weil setErrors ueber setState laeuft: der rote Rahmen und damit auch der
     * Rueckfall ueber ".error" existieren erst nach dem naechsten Rendern.
     */
    focusFirstError(errors) {
        if (typeof document === "undefined" || !errors) {
            return;
        }
        setTimeout(() => {
            const container = document.getElementById("questionwrapper");
            if (!container) {
                return;
            }
            let target = null;
            for (const q of (this.qCtrl().getCurrentQuestionsForPage() || [])) {
                if (!q || !errors[q.id]) {
                    continue;
                }
                target = document.getElementById("question-" + q.id);
                if (target) {
                    break;
                }
            }
            // Kindfragen in Akkordions haben keinen eigenen Anker. Dann das erste als
            // fehlerhaft markierte Element im linken Bereich nehmen.
            if (!target) {
                target = container.querySelector(".error");
            }
            if (!target) {
                return;
            }
            scrollElementIntoViewInContainer(target, container);
            flashElement(target);
        }, 50);
    }

    next() {
        this.fireEvent("pageChanged");
        const errors = this.qCtrl().checkForAnswersBeforeStep();
        if (errors == null) {
            this.qCtrl().nextQuestionPage(() => {
                this.jumpToTop();
            });
        }
        else {
            this.focusFirstError(errors);
        }
    }

    summary(e) {
        this.fireEvent("pageChanged");
        const errors = this.qCtrl().checkForAnswersBeforeStep();
        if (errors == null) {
            this.props.onResultsPageClicked(e);
        }
        else {
            this.focusFirstError(errors);
        }
    }

    back(e) {
        this.fireEvent("pageChanged");
        this.qCtrl().stepBack(() => {
            this.jumpToTop();
        });
    }

    isLastQuestion() {
        return this.qCtrl().isCurrentLastQuestion();
    }

    render() {
        return <Container className={"questioncontainer p-0"} fluid={true}>
            <Row>
                <Col md={12}>
                    <QuestionGroup {...this.props}></QuestionGroup>
                </Col>
                <div className={"col-md-5 footer-container"}>
                    <hr/>
                    <Row>
                        <Col sm={6}>
                            <Button onClick={(e) => this.back(e)} className={"back-button"} color={"None"}>&lt; Zurück</Button>
                        </Col>
                        <Col sm={6} >
                            {!this.isLastQuestion() && <Button  onClick={(e) => this.next(e)} color={"primary"}  className={"float-right"}>Weiter</Button>}
                            {this.isLastQuestion() && <Button  onClick={(e) => this.summary(e)} color={"primary"}  className={"float-right"}>Zusammenfassung</Button>}
                        </Col>
                    </Row>
                </div>
            </Row>
        </Container>
            ;
    }
};

QuestionPageContainer.propTypes = {

};


export default QuestionPageContainer;
